(function () {
	const container = document.currentScript.parentElement;

	const swiper = new Swiper(container, {
		speed: 800,
		spaceBetween: 100,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
	});

})();